(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jamr-crown-effects"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jamr-crown')) {
    customElements.define('jamr-crown', class extends HTMLElement {
      connectedCallback() {
        this.crownSection = this.closest('.announcement-bar-section');
        if (!this.crownSection) return;
        const syncHeight = () => {
          const height = this.crownSection.getBoundingClientRect().height;
          if (height === this.crownHeight) return;
          this.crownHeight = height;
          document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
        };
        syncHeight();
        this.crownObserver = new ResizeObserver(syncHeight);
        this.crownObserver.observe(this.crownSection);
      }

      disconnectedCallback() {
        if (this.crownObserver) this.crownObserver.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
